(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-hero-png-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-video-hero-slider')) {
    class PBVideoHeroSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.viewport = this.querySelector('.slider__slides');
        this.frames = [...this.querySelectorAll('.slider__slide')];
        this.slides = this.frames.map((frame) => frame.querySelector('.vh-slide'));
        this.dots = [...this.querySelectorAll('[data-pb-dot]')];
        this.liveRegion = this.querySelector('[data-pb-live]');
        this.motionButton = this.querySelector('[data-pb-action="toggle-motion"]');
        this.previousButton = this.querySelector('[data-pb-action="previous"]');
        this.nextButton = this.querySelector('[data-pb-action="next"]');

        if (!this.viewport || !this.frames.length || this.slides.some((slide) => !slide)) {
          this.initialized = false;
          return;
        }

        this.activeIndex = 0;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplayDelay = Math.max(3000, Number(this.dataset.autoplayDelay) || 5000);
        this.loopSlides = this.dataset.loopSlides !== 'false';
        this.pauseOnInteraction = this.dataset.pauseOnInteraction === 'true';
        this.videoAutoplayEnabled = this.dataset.videoAutoplay === 'true';
        this.motionPaused = false;
        this.editorPaused = false;
        this.interactionPaused = false;
        this.pointerActive = false;
        this.pointerHover = false;
        this.focusWithin = false;
        this.rootIsVisible = true;
        this.announceNextChange = false;
        this.autoplayTimer = 0;
        this.settleTimer = 0;
        this.interactionResumeTimer = 0;
        this.geometryRaf = 0;
        this.headerRaf = 0;
        this.ownerId = this.dataset.sectionId || this.id;
        this.currentLogoMode = 'original';
        this.logoElements = [];
        this.headerElement = null;
        this.slideRatios = new Map();
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.canHover = window.matchMedia('(hover: hover)').matches;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleMotionPreference = this.handleMotionPreference.bind(this);
        this.handleGeometryChange = this.handleGeometryChange.bind(this);
        this.handlePageScroll = this.handlePageScroll.bind(this);
        this.handleHeaderStructureChange = this.handleHeaderStructureChange.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
        this.handlePointerEnter = this.handlePointerEnter.bind(this);
        this.handlePointerLeave = this.handlePointerLeave.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);

        this.prepareVideos();
        this.addEventListener('click', this.handleClick);
        this.viewport.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        if (this.pauseOnInteraction) {
          this.addEventListener('mouseenter', this.handlePointerEnter);
          this.addEventListener('mouseleave', this.handlePointerLeave);
          this.addEventListener('pointerdown', this.handlePointerDown, { passive: true });
          this.addEventListener('pointerup', this.handlePointerUp, { passive: true });
          this.addEventListener('pointercancel', this.handlePointerUp, { passive: true });
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
        }

        if (this.reduceMotion.addEventListener) {
          this.reduceMotion.addEventListener('change', this.handleMotionPreference);
        } else {
          this.reduceMotion.addListener(this.handleMotionPreference);
        }

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.rootIsVisible = entry.isIntersecting;

          if (this.rootIsVisible) {
            this.refreshMotion();
            this.applyHeaderLogoMode();
          } else {
            this.stopAutoplay();
            this.pauseAllVideos();
            this.clearHeaderLogoMode();
          }
        }, { threshold: 0.2 });

        this.visibilityObserver.observe(this);

        this.slideObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const index = this.frames.indexOf(entry.target);
            if (index >= 0) this.slideRatios.set(index, entry.intersectionRatio);
          });

          let bestIndex = this.activeIndex;
          let bestRatio = this.slideRatios.get(bestIndex) || 0;

          this.slideRatios.forEach((ratio, index) => {
            if (ratio > bestRatio + 0.001) {
              bestIndex = index;
              bestRatio = ratio;
            }
          });

          if (bestRatio > 0) this.setActive(bestIndex);
        }, {
          root: this.viewport,
          threshold: [0.25, 0.5, 0.75, 0.9, 1]
        });

        this.frames.forEach((frame) => this.slideObserver.observe(frame));
        this.connectHeaderObservers();
        this.updateMotionButton();

        requestAnimationFrame(() => {
          this.setActive(this.getActiveIndex(), { force: true });
          this.viewport.setAttribute('tabindex', '0');
          this.viewport.setAttribute('aria-label', this.dataset.viewportLabel || '');
        });
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.stopAutoplay();
        window.clearTimeout(this.settleTimer);
        window.clearTimeout(this.interactionResumeTimer);
        cancelAnimationFrame(this.geometryRaf);
        cancelAnimationFrame(this.headerRaf);
        this.visibilityObserver?.disconnect();
        this.slideObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.headerMutationObserver?.disconnect();
        this.headerContainerObserver?.disconnect();
        this.clearHeaderLogoMode();
        this.pauseAllVideos();

        this.removeEventListener('click', this.handleClick);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        window.removeEventListener('scroll', this.handlePageScroll);
        window.removeEventListener('resize', this.handleGeometryChange);

        if (this.pauseOnInteraction) {
          this.removeEventListener('mouseenter', this.handlePointerEnter);
          this.removeEventListener('mouseleave', this.handlePointerLeave);
          this.removeEventListener('pointerdown', this.handlePointerDown);
          this.removeEventListener('pointerup', this.handlePointerUp);
          this.removeEventListener('pointercancel', this.handlePointerUp);
          this.removeEventListener('focusin', this.handleFocusIn);
          this.removeEventListener('focusout', this.handleFocusOut);
        }

        if (this.reduceMotion?.removeEventListener) {
          this.reduceMotion.removeEventListener('change', this.handleMotionPreference);
        } else {
          this.reduceMotion?.removeListener(this.handleMotionPreference);
        }

        if (this.logoBreakpointMedia?.removeEventListener) {
          this.logoBreakpointMedia.removeEventListener('change', this.handleGeometryChange);
        } else {
          this.logoBreakpointMedia?.removeListener(this.handleGeometryChange);
        }

        this.initialized = false;
      }

      prepareVideos() {
        this.slides.forEach((slide) => {
          slide.querySelectorAll('video').forEach((video) => {
            video.autoplay = false;
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.removeAttribute('autoplay');
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            video.removeAttribute('controls');

            if (video.dataset.pbPrepared === 'true') return;
            video.dataset.pbPrepared = 'true';

            video.addEventListener('playing', () => {
              slide.querySelector('.hero-media')?.classList.add('is-playing');
            });

            video.addEventListener('error', () => {
              slide.querySelector('.hero-media')?.classList.remove('is-playing');
            });

            video.addEventListener('ended', () => {
              if (!video.loop) slide.querySelector('.hero-media')?.classList.remove('is-playing');
            });
          });
        });
      }

      prepareVideoWindow(activeIndex) {
        const nearby = new Set();

        [-1, 1].forEach((offset) => {
          let index = activeIndex + offset;

          if (this.loopSlides) {
            index = this.normalizeIndex(index);
          }

          if (index >= 0 && index < this.slides.length && index !== activeIndex) {
            nearby.add(index);
          }
        });

        const preloadRank = { none: 0, metadata: 1, auto: 2 };

        this.slides.forEach((slide, index) => {
          const requestedPreload = index === activeIndex ? 'auto' : nearby.has(index) ? 'metadata' : null;
          if (!requestedPreload) return;

          slide.querySelectorAll('video').forEach((video) => {
            const currentPreload = video.getAttribute('preload') || 'none';
            if (preloadRank[currentPreload] >= preloadRank[requestedPreload]) return;

            video.preload = requestedPreload;
            video.setAttribute('preload', requestedPreload);
            video.load();
          });
        });
      }

      getActiveIndex() {
        const viewportRect = this.viewport.getBoundingClientRect();
        let bestIndex = 0;
        let bestVisibleWidth = -1;
        let bestDistance = Infinity;

        this.frames.forEach((frame, index) => {
          const rect = frame.getBoundingClientRect();
          const visibleWidth = Math.max(
            0,
            Math.min(rect.right, viewportRect.right) - Math.max(rect.left, viewportRect.left)
          );
          const distance = Math.abs(rect.left - viewportRect.left);

          if (visibleWidth > bestVisibleWidth ||
            (visibleWidth === bestVisibleWidth && distance < bestDistance)) {
            bestIndex = index;
            bestVisibleWidth = visibleWidth;
            bestDistance = distance;
          }
        });

        return bestIndex;
      }

      setActive(index, { force = false } = {}) {
        if (!this.slides[index]) return;

        const changed = index !== this.activeIndex;
        this.activeIndex = index;

        this.frames.forEach((frame, frameIndex) => {
          const isActive = frameIndex === index;
          frame.classList.toggle('is-active', isActive);
          frame.toggleAttribute('inert', !isActive);
          this.slides[frameIndex].classList.toggle('is-active', isActive);
          this.slides[frameIndex].setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        this.updateArrowStates();

        if (changed || force) {
          this.prepareVideoWindow(index);
          this.slides.forEach((slide, slideIndex) => {
            if (slideIndex !== index) this.stopVideo(slide);
          });
          this.playActiveVideo();
          this.applyHeaderLogoMode();

          if (this.announceNextChange && this.liveRegion) {
            this.liveRegion.textContent = this.slides[index].dataset.slideLabel || '';
          }
          this.announceNextChange = false;
        }

        this.scheduleAutoplay();
      }

      normalizeIndex(index) {
        if (this.loopSlides) {
          return (index + this.frames.length) % this.frames.length;
        }

        return Math.min(Math.max(index, 0), this.frames.length - 1);
      }

      updateArrowStates() {
        if (this.previousButton) {
          this.previousButton.disabled = !this.loopSlides && this.activeIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled = !this.loopSlides && this.activeIndex === this.frames.length - 1;
        }
      }

      isRtl() {
        return getComputedStyle(this).direction === 'rtl' || document.documentElement.dir === 'rtl';
      }

      goTo(index, { announce = false, manual = false, behavior } = {}) {
        const normalizedIndex = this.normalizeIndex(index);
        const target = this.frames[normalizedIndex];
        if (!target) return;

        if (manual) {
          this.stopAutoplay();
        }

        this.announceNextChange = announce;
        const scrollBehavior = behavior || (this.reduceMotion.matches ? 'auto' : 'smooth');

        const viewportRect = this.viewport.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const left = this.isRtl()
          ? targetRect.right - viewportRect.right
          : targetRect.left - viewportRect.left;

        this.viewport.scrollBy({ left, behavior: scrollBehavior });

        window.clearTimeout(this.settleTimer);
        this.settleTimer = window.setTimeout(() => {
          this.setActive(normalizedIndex);
        }, scrollBehavior === 'smooth' ? 500 : 0);
      }

      handleClick(event) {
        const dot = event.target.closest('[data-pb-dot]');
        if (dot && this.contains(dot)) {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(Number(dot.dataset.dotIndex), { announce: true, manual: true });
          return;
        }

        const action = event.target.closest('[data-pb-action]');
        if (!action || !this.contains(action)) return;

        event.preventDefault();
        event.stopPropagation();

        if (action.dataset.pbAction === 'previous') {
          this.goTo(this.activeIndex - 1, { announce: true, manual: true });
        } else if (action.dataset.pbAction === 'next') {
          this.goTo(this.activeIndex + 1, { announce: true, manual: true });
        } else if (action.dataset.pbAction === 'toggle-motion') {
          this.toggleMotion();
        }
      }

      handleKeydown(event) {
        if (event.target !== this.viewport) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.activeIndex + (this.isRtl() ? 1 : -1), { announce: true, manual: true });
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.activeIndex + (this.isRtl() ? -1 : 1), { announce: true, manual: true });
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.goTo(0, { announce: true, manual: true });
        } else if (event.key === 'End') {
          event.preventDefault();
          this.goTo(this.frames.length - 1, { announce: true, manual: true });
        }
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
          this.pauseAllVideos();
        } else {
          this.refreshMotion();
        }
      }

      handleMotionPreference() {
        this.updateMotionButton();
        this.refreshMotion();
      }

      handleGeometryChange() {
        cancelAnimationFrame(this.geometryRaf);
        this.geometryRaf = requestAnimationFrame(() => {
          this.setActive(this.getActiveIndex());
          this.applyHeaderLogoMode();
        });
      }

      handlePageScroll() {
        cancelAnimationFrame(this.headerRaf);
        this.headerRaf = requestAnimationFrame(() => this.applyHeaderLogoMode());
      }

      handlePointerEnter() {
        if (!this.canHover) return;
        this.pointerHover = true;
        this.setInteractionPaused(true);
      }

      handlePointerLeave() {
        this.pointerHover = false;
        if (!this.focusWithin && !this.pointerActive) this.setInteractionPaused(false, 800);
      }

      handlePointerDown() {
        this.pointerActive = true;
        this.setInteractionPaused(true);
      }

      handlePointerUp() {
        this.pointerActive = false;
        if (!this.pointerHover && !this.focusWithin) this.setInteractionPaused(false, 1200);
      }

      handleFocusIn() {
        this.focusWithin = true;
        this.setInteractionPaused(true);
      }

      handleFocusOut() {
        requestAnimationFrame(() => {
          this.focusWithin = this.matches(':focus-within');
          if (!this.focusWithin && !this.pointerHover && !this.pointerActive) {
            this.setInteractionPaused(false, 800);
          }
        });
      }

      setInteractionPaused(paused, resumeDelay = 0) {
        window.clearTimeout(this.interactionResumeTimer);

        if (paused) {
          this.interactionPaused = true;
          this.stopAutoplay();
          return;
        }

        this.interactionResumeTimer = window.setTimeout(() => {
          if (this.pointerHover || this.focusWithin || this.pointerActive) return;
          this.interactionPaused = false;
          this.scheduleAutoplay();
        }, resumeDelay);
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest?.('.vh-slide');
        if (!selectedSlide || !this.contains(selectedSlide)) return;

        const index = this.slides.indexOf(selectedSlide);
        if (index < 0) return;

        this.editorPaused = true;
        this.stopAutoplay();
        this.goTo(index, { announce: false, manual: false, behavior: 'auto' });
      }

      handleBlockDeselect(event) {
        if (!this.contains(event.target)) return;
        this.editorPaused = false;
        this.scheduleAutoplay();
      }

      canRotate() {
        return this.autoplayEnabled &&
          this.frames.length > 1 &&
          !this.motionPaused &&
          !this.editorPaused &&
          !this.interactionPaused &&
          !this.reduceMotion.matches &&
          this.rootIsVisible &&
          !document.hidden &&
          (this.loopSlides || this.activeIndex < this.frames.length - 1);
      }

      scheduleAutoplay() {
        this.stopAutoplay();
        if (!this.canRotate()) return;

        this.autoplayTimer = window.setTimeout(() => {
          this.goTo(this.activeIndex + 1, { announce: false, manual: false });
        }, this.autoplayDelay);
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = 0;
      }

      canPlayVideo() {
        return this.videoAutoplayEnabled &&
          !this.motionPaused &&
          !this.reduceMotion.matches &&
          this.rootIsVisible &&
          !document.hidden;
      }

      playActiveVideo() {
        if (!this.canPlayVideo()) return;

        const slide = this.slides[this.activeIndex];
        slide?.querySelectorAll('video').forEach((video) => {
          if (video.paused) {
            video.play().catch(() => {
              slide.querySelector('.hero-media')?.classList.remove('is-playing');
            });
          }
        });
      }

      stopVideo(slide) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelector('.hero-media')?.classList.remove('is-playing');
      }

      pauseAllVideos() {
        this.slides.forEach((slide) => this.stopVideo(slide));
      }

      refreshMotion() {
        if (this.canPlayVideo()) this.playActiveVideo();
        else this.pauseAllVideos();

        this.scheduleAutoplay();
      }

      toggleMotion() {
        if (this.reduceMotion.matches) return;

        this.motionPaused = !this.motionPaused;

        if (this.motionPaused) {
          this.stopAutoplay();
          this.pauseAllVideos();
        } else {
          this.refreshMotion();
        }

        this.updateMotionButton();
      }

      updateMotionButton() {
        if (!this.motionButton) return;

        if (this.reduceMotion.matches) {
          this.motionButton.disabled = true;
          this.motionButton.setAttribute('aria-label', this.motionButton.dataset.labelReduced);
          return;
        }

        this.motionButton.disabled = false;
        this.motionButton.setAttribute('aria-pressed', this.motionPaused ? 'true' : 'false');
        this.motionButton.setAttribute(
          'aria-label',
          this.motionPaused ? this.motionButton.dataset.labelPlay : this.motionButton.dataset.labelPause
        );
      }

      getHeaderLogoElements() {
        const selector = this.dataset.headerLogoSelector?.trim();

        if (selector) {
          try {
            const selected = [...document.querySelectorAll(selector)];
            if (selected.length) return selected;
          } catch (error) {
            // A malformed merchant selector falls back to the safe search below.
          }
        }

        const header = this.getHeaderElement();
        if (!header) return [];

        return [...header.querySelectorAll('img')].filter((image) => {
          const data = `${image.alt || ''} ${image.src || ''} ${image.className || ''}`.toLowerCase();
          return data.includes('logo') || data.includes('plastic') || data.includes('books') ||
            Boolean(image.closest('.header__heading, .header__heading-link'));
        });
      }

      getHeaderElement() {
        const selector = this.dataset.headerLogoSelector?.trim();

        if (selector) {
          try {
            const selected = document.querySelector(selector);
            const selectedHeader = selected?.closest(
              '#shopify-section-header, [id*="shopify-section-header"], .shopify-section-header, header'
            );
            if (selectedHeader) return selectedHeader;
          } catch (error) {
            // A malformed merchant selector falls back to the standard header search.
          }
        }

        return document.querySelector('#shopify-section-header') ||
          document.querySelector('.shopify-section-header') ||
          document.querySelector('header') ||
          document.querySelector('[id*="shopify-section-header"]');
      }

      connectHeaderObservers() {
        const nextHeader = this.getHeaderElement();

        window.removeEventListener('scroll', this.handlePageScroll);
        if (this.logoBreakpointMedia?.removeEventListener) {
          this.logoBreakpointMedia.removeEventListener('change', this.handleGeometryChange);
        } else {
          this.logoBreakpointMedia?.removeListener(this.handleGeometryChange);
        }

        if (this.headerElement && this.headerElement !== nextHeader) {
          this.resizeObserver?.unobserve(this.headerElement);
        }

        this.headerElement = nextHeader;
        this.headerMutationObserver?.disconnect();
        this.headerContainerObserver?.disconnect();

        if (!this.resizeObserver && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleGeometryChange);
          this.resizeObserver.observe(this.viewport);
        } else if (!('ResizeObserver' in window)) {
          window.addEventListener('resize', this.handleGeometryChange, { passive: true });
        }

        if (this.headerElement) {
          this.resizeObserver?.observe(this.headerElement);
          this.headerMutationObserver = new MutationObserver(() => {
            this.currentLogoMode = null;
            this.applyHeaderLogoMode();
          });
          this.headerMutationObserver.observe(this.headerElement, { childList: true, subtree: true });
        }

        const headerContainer = this.headerElement?.parentElement || document.body;
        if (headerContainer) {
          this.headerContainerObserver = new MutationObserver(this.handleHeaderStructureChange);
          this.headerContainerObserver.observe(headerContainer, {
            childList: true,
            subtree: !this.headerElement
          });
        }

        if (this.dataset.headerLogoEnabled === 'true') {
          window.addEventListener('scroll', this.handlePageScroll, { passive: true });

          const breakpoint = Number(this.dataset.headerLogoBreakpoint) || 990;
          this.logoBreakpointMedia = window.matchMedia(`(min-width: ${breakpoint}px)`);

          if (this.logoBreakpointMedia.addEventListener) {
            this.logoBreakpointMedia.addEventListener('change', this.handleGeometryChange);
          } else {
            this.logoBreakpointMedia.addListener(this.handleGeometryChange);
          }
        }
      }

      handleHeaderStructureChange() {
        const nextHeader = this.getHeaderElement();
        if (nextHeader !== this.headerElement) {
          this.connectHeaderObservers();
        }

        this.currentLogoMode = null;
        this.applyHeaderLogoMode();
      }

      headerOverlapsActiveHero() {
        const header = this.headerElement || this.getHeaderElement();
        const hero = this.slides[this.activeIndex]?.querySelector('.pb-vh__hero');
        if (!header || !hero) return false;

        const headerRect = header.getBoundingClientRect();
        const heroRect = hero.getBoundingClientRect();
        const overlapWidth = Math.min(headerRect.right, heroRect.right) - Math.max(headerRect.left, heroRect.left);
        const overlapHeight = Math.min(headerRect.bottom, heroRect.bottom) - Math.max(headerRect.top, heroRect.top);

        return overlapWidth > 1 && overlapHeight > 1;
      }

      applyHeaderLogoMode() {
        const enabled = this.dataset.headerLogoEnabled === 'true';
        const desktopOnly = this.dataset.headerLogoDesktopOnly === 'true';
        const isDesktop = this.logoBreakpointMedia?.matches ?? true;
        let mode = this.slides[this.activeIndex]?.dataset.pbHeaderLogoMode || 'original';

        if (!enabled || !this.rootIsVisible || (desktopOnly && !isDesktop) || !this.headerOverlapsActiveHero()) {
          mode = 'original';
        }

        const logoStateIsValid = mode === 'original' || (
          this.logoElements.length > 0 &&
          this.logoElements.every((element) =>
            element.isConnected &&
            element.dataset.pbHeaderLogoOwner === this.ownerId &&
            element.classList.contains(`pb-vh-logo--${mode}`)
          )
        );

        if (mode === this.currentLogoMode && logoStateIsValid) return;

        this.clearHeaderLogoMode(false);
        this.currentLogoMode = mode;
        if (mode === 'original') return;

        this.logoElements = this.getHeaderLogoElements();
        if (!this.logoElements.length) {
          this.currentLogoMode = 'original';
          return;
        }

        this.logoElements.forEach((element) => {
          element.dataset.pbHeaderLogoOwner = this.ownerId;
          element.classList.toggle('pb-vh-logo--black', mode === 'black');
          element.classList.toggle('pb-vh-logo--white', mode === 'white');
        });
      }

      clearHeaderLogoMode(resetCurrentMode = true) {
        this.logoElements?.forEach((element) => {
          if (element.dataset.pbHeaderLogoOwner !== this.ownerId) return;
          element.classList.remove('pb-vh-logo--black', 'pb-vh-logo--white');
          delete element.dataset.pbHeaderLogoOwner;
        });
        this.logoElements = [];
        if (resetCurrentMode) this.currentLogoMode = 'original';
      }
    }

    customElements.define('pb-video-hero-slider', PBVideoHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
